// extracted by mini-css-extract-plugin
export var bounce = "_lg-1";
export var generatingText = "_lg-6";
export var lightning = "_lg-4";
export var popup = "_lg-5";
export var progressBar = "_lg-7";
export var progressFill = "_lg-8";
export var progressShimmer = "_lg-9";
export var progressText = "_lg-a";
export var shimmer = "_lg-3";
export var uploadIcon = "_lg-0";
export var uploadingText = "_lg-2";